/**
 * Detects whether this document runs inside the Plaintr mobile wrapper.
 *
 * `window.Capacitor` is deliberately not used: it does not exist on the remote
 * origin. The safe-area custom properties are the primary marker because the
 * wrapper injects them as a document-start script for all origins, so they are
 * set before any page script runs, on both platforms and in the published
 * build. The push bridge is a fallback, injected later in the page lifecycle.
 */

const SAFE_AREA_PROPERTY = "--plaintr-safe-area-top";

function hasSafeAreaMarker() {
  const root = document.documentElement;
  if (root === null) {
    return false;
  }
  // Read the inline style first: that is where the wrapper writes, and it
  // avoids a layout-dependent computed-style read.
  if (root.style.getPropertyValue(SAFE_AREA_PROPERTY).trim() !== "") {
    return true;
  }
  try {
    return window.getComputedStyle(root).getPropertyValue(SAFE_AREA_PROPERTY).trim() !== "";
  } catch {
    return false;
  }
}

/** True only inside the Plaintr mobile wrapper WebView. */
export function isRunningInPlaintrWrapper() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  return hasSafeAreaMarker() || typeof window.PlaintrMobilePushBridge !== "undefined";
}
